export const colors = {
  oldAgroweGreen: '#008651',
  agroweGreen: '#118553',
  agroweToxicGreen: '#35FEA9',
  pink: '#FF4081',
  white: '#FFFFFF',
  black: '#000000',
  redButton: '#C62828',
  disabledButton: '#BABABA',
  redError: '#C72F24',
  paper: '#EAEFF1',
  rowLight: '#F5F5F5',
  rowDark: '#E0E0E0',
  yellow: '#FCBB40',
  brightYellow: '#FFEB3B',
};

export default colors;
